export const DESKTOP_WIDTH = 1440

export const MOBILE_SCREEN_MAX_WIDTH = 960

export const MOBILE_SCREEN_MIN_WIDTH = 441

export const FORM_MOBILE_ACTIONS_MAX_WIDTH = 600
